import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TitleSection } from './Hero.styles';
import PrimaryButtonComponent from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import MediumPic from '../../../Visuals/Images/medium.jpg';
import SecondaryButton from '../../../Components/Buttons/SecondaryButton/SecondaryButton.component';
const HeroSection = () => {
  const navigate = useNavigate();

  const gotToTraining = () => {
    navigate('/training');
  };
  const goToContact = () => {
    navigate('/contact-us');
  };
  return (
    <TitleSection>
      <div className="overlay">
        <img src={MediumPic} loading="eager" alt="Construction Site" />
      </div>

      <div className="text">
        <p className="heroEyebrow">Workplace Safety & Compliance</p>
        <h1>
          Build safer <span className="yellow">workplaces</span>
        </h1>
        <p className="heroSubtext">
          Online training, workplace audits, safety manuals, and compliance
          solutions designed to support teams across Atlantic Canada.
        </p>

        <div className="heroActions">
          <PrimaryButtonComponent
            span="Explore Training"
            functionName={gotToTraining}
          />

          <SecondaryButton span="Contact Our Team" functionName={goToContact} />
        </div>
      </div>
    </TitleSection>
  );
};

export default HeroSection;
